import axios from 'axios';
import * as Config from '../../config';

const state = {
    
};

const actions = {
    invoice_max_amount_get_last({ commit, dispatch }) {
        return new Promise((resolve, reject) => {
            axios.get(Config.apiPath + 'invoice-max-amount/get-last')
                .then(
                    response => {
                        resolve(response.data);
                    })
                .catch(error => {
                    reject(error.response.data);
                });
        });
    },
    invoice_max_amount_get_all({ commit, dispatch }) {
        return new Promise((resolve, reject) => {
            axios.get(Config.apiPath + 'invoice-max-amount/get-all')
                .then(
                    response => {
                        resolve(response.data);
                    })
                .catch(error => {
                    reject(error.response.data);
                });
        });
    },
    invoice_max_amount_update_store({ commit, dispatch }, form) {
        return new Promise((resolve, reject) => {
            axios.post(Config.apiPath + 'invoice-max-amount/update-store', form)
                .then(
                    response => {
                        resolve(response.data);
                    })
                .catch(error => {
                    reject(error.response.data);
                });
        });
    }
}

const mutations = {

};

export default {
    state,
    actions,
    mutations
};